import {Payload} from '../../../payload/payload';
import {BehaviorSubject, Observable} from 'rxjs';
import {HttpClient, HttpContext, HttpHeaders, HttpParams} from '@angular/common/http';
import {IActionService} from './iaction.service';

export abstract class BaseActionService<P extends Payload, Result> implements IActionService<P>{

    readonly loading$: Observable<boolean> = new BehaviorSubject(false);
    readonly error$: Observable<any> = new BehaviorSubject(undefined);
    readonly result$: Observable<Result> = new BehaviorSubject(undefined);

    readonly url: string;
    private readonly httpClient: HttpClient;
    private previousPayload: P;

    protected constructor(url: string,
                          httpClient: HttpClient) {
        this.url = url;
        this.httpClient = httpClient;
    }

    buildOptions(payload: P): {
        headers?: HttpHeaders | {
            [header: string]: string | string[];
        };
        context?: HttpContext;
        observe?: 'body';
        params?: HttpParams | {
            [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
        };
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    } {
        return undefined;
    }

    reExecute() {
        if (this.previousPayload) {
            this.executeAction(this.previousPayload);
        }
    }

    executeAction(payload: P): Promise<Result> {
        this.previousPayload = payload;
        const url = this.url;
        const promise = this.httpClient.post<any>(url, this.buildBody(payload), this.buildOptions(payload)).toPromise();
        this.setLoading(true);
        (this.result$ as BehaviorSubject<Result>).next(undefined);
        return new Promise<Result>((resolve, reject) => {
            promise
                .then((response) => {
                    const formattedResponse = this.buildResponse(response);
                    this.onResponse(formattedResponse, payload);
                    (this.result$ as BehaviorSubject<Result>).next(formattedResponse);
                    resolve(formattedResponse);
                })
                .catch((e) => {
                    this.setError(e);
                    reject(e);
                })
                .finally(() => this.setLoading(false));
        });
    }

    protected buildBody(payload: P): any {
        return payload;
    }

    protected buildResponse(response: any): Result {
        return response;
    }

    protected setLoading(loading: boolean) {
        (this.loading$ as BehaviorSubject<boolean>).next(loading);
    }

    protected setError(error: any) {
        (this.error$ as BehaviorSubject<any>).next(error);
    }

    protected onResponse(response: Result, payload: P): void {
    }

    get resultSnapshot() : Result {
        return (this.result$ as BehaviorSubject<Result>).value;
    }

}
